export const hasUsableLoginRedirectValue = (value) => {
  if (value === undefined || value === null) return false;

  const normalizedValue = String(value).trim();
  return normalizedValue !== "" && normalizedValue !== "undefined" && normalizedValue !== "null";
};

export const hasLoginCaseContext = (clientId, caseId) =>
  hasUsableLoginRedirectValue(clientId) && hasUsableLoginRedirectValue(caseId);

export const resolveLoginRedirect = ({ clientId, caseId, redirectPageId, redirectUrl }) => {
  if (
    !hasLoginCaseContext(clientId, caseId) ||
    !hasUsableLoginRedirectValue(redirectPageId) ||
    !hasUsableLoginRedirectValue(redirectUrl)
  ) {
    return "/search/";
  }

  const route = String(redirectUrl)
    .trim()
    .replace(/^\/+|\/+$/g, "");

  if (!route || route === "search") return "/search/";
  if (route === "bp-medicalmin") return "/treatment";

  return `/${route}/${clientId}/${caseId}`;
};
